import { createApp } from 'vue'
import App from './App.vue'
import ArticlesSwiper from './articles.swiper.vue'
import DrawChart from './chart.draw';
import VideoSwiper from './video.swiper.vue'

import store from './store'

import './scss/index.scss'

htmlReady(() => {
	render(App, '#knd-app');
	render(ArticlesSwiper, '#knd-articles-swiper');
	render(DrawChart, '#knd-chart');
	render(VideoSwiper, '#knd-video-swiper');
})

function render(comp, id) {
	if(!document.querySelector(id)) {
		console.log(id + ' is not defined!');
	}
	
	createApp(comp).use(store).mount(id)
}

// wait till everything is rendered 
function htmlReady(cb){
	// in case the document is already rendered
	if (document.readyState!='loading'){
		cb();
	}

	// modern browsers
	else if (document.addEventListener){ 
		document.addEventListener('DOMContentLoaded', cb);
	}
	// IE <= 8
	else document.attachEvent('onreadystatechange',() => {
		if (document.readyState=='complete') cb();
	});
}